import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

export default function Social() {
    return (
        <section className="social px-2">
            <ul className="d-flex justify-content-center space-between gap-4">
                <li>
                    <a href="mailto:ndeimler@gmail.com" target="_blank" rel="noopener noreferrer" title="Email Nick">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/nickdeimler/" target="_blank" rel="noopener noreferrer" title="Nick's LinkedIn Profile">
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                </li>
            </ul>
        </section>
    );
}
